import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { useCard } from '../../../hooks/useCard';

export const useCards = () => {
  const { slug } = useParams();
  const { fetchCardItem } = useActions();
  const [isSmashed, setIsSmashed] = useState(false);
  const { catalog_item, page_description, navigation, isLoading } = useCard();

  //Показать адрес
  const [showAddress, setShowAddress] = useState(false);
  //Переключать "Показать адрес"
  const handleShowAddress = () => setShowAddress(!showAddress);
  //Если описания нет, то вставляем "Нет описания"
  const parametersText = catalog_item?.parameters
    ? catalog_item?.parameters
    : 'Нет описания..';

  //Индекс активного изображения в галереи
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  //Переключать активное изображение
  const handleSetActiveImageIndex = (index: number) =>
    setActiveImageIndex(index);
  //Показать больше. На моб. версии
  const [showMore, setShowMore] = useState(false);
  //Переключать описание "Показать больше" НА МОБ. ВЕРСИИ
  const handleShowMore = () => setShowMore(!showMore);

  //При изменении параметров(slug) вызываем API
  useEffect(() => {
    if (slug) fetchCardItem({ slug });
  }, [slug]);

  return useMemo(
    () => ({
      card: {
        activeImageIndex,
        isLoading,
        catalog_item,
        navigation,
        parametersText,
        showAddress,
        showMore,
      },
      actions: { handleSetActiveImageIndex, handleShowAddress, handleShowMore },
    }),
    [
      activeImageIndex,
      isLoading,
      catalog_item,
      navigation,
      parametersText,
      showAddress,
      showMore,
    ]
  );
};
